module.exports = __webpack_public_path__ + "media/images/metronic/datatables/forward_disabled-8d521190ae1ae077de19a6b5ca189d70.png";